import { render } from "./BorrowLend.vue?vue&type=template&id=204d4794"
import script from "./BorrowLend.vue?vue&type=script&lang=js"
export * from "./BorrowLend.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/defi/BorrowLend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "204d4794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('204d4794', __exports__)) {
    api.reload('204d4794', __exports__)
  }
  
  module.hot.accept("./BorrowLend.vue?vue&type=template&id=204d4794", () => {
    api.rerender('204d4794', render)
  })

}


export default __exports__